module.exports = __webpack_public_path__ + "img/warehouse-img.4fe844c9.png";